/* eslint-disable indent */
import React, { useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import Skeleton from "react-loading-skeleton";

import Starter from "../../component/Starter";
import Button from "../../component/button/Button";
import SelectInput2 from "../../component/input/SelectInput2";
import Strong from "../../component/smallComponents/Strong";
import P from "../../component/smallComponents/P";
import HeaderTag from "../../component/smallComponents/HeaderTag";
import SpinnerButton from "../../component/spinner/SpinnerButton";
import Card from "../../component/card/Card";
import {
  isSuperAdmin,
  renderAccessLocation2,
  renderLocationFunction,
  locationRender
} from "../../constant/helper/helper";
import { helperFunction } from "../../constant/helper";
import TextInput from "../../component/input/TextInput";
import SelectInput from "../../component/input/SelectInput";
import { canteenActions } from "../../redux/actions";
import isEmpty from "../../validation/isEmpty";

const initialState = {
  breakFastIn: "",
  breakFastOut: "",
  lunchIn: "",
  lunchOut: "",
  dinnerIn: "",
  dinnerOut: "",
  locationId: ""
};

const CreateCanteenRule = () => {
  const dispatch = useDispatch();
  const loginType = localStorage.loginType;
  const [locationId, setLocationId] = useState("");
  const [values, setValues] = useState(initialState);
  const [allLocations, setAllLocations] = useState([]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
  };

  const onLocationChange = (e) => {
    const { value } = e.target;
    setLocationId(value);
    dispatch(canteenActions.setCanteenLoading(true));
    dispatch(canteenActions.clearCanteenErrors());
    dispatch(canteenActions.clearCanteenResult());
    dispatch(canteenActions.getCanteenRule(value, loginType));
  };

  const { locationError, locations } = useSelector(
    (state) => state.location
  );
  const { currentUser } = useSelector((state) => state.auth);
  const {
    createCanteenRuleLoading,
    canteenResponse,
    allCanteenRules,
    canteenLoading
  } = useSelector((state) => state.canteen);

  useEffect(() => {
    if (locationError) {
      helperFunction.toastHelper("error", locationError);
    }
    if (canteenResponse) {
      helperFunction.toastHelper("success", canteenResponse);
    }
  }, [locationError, canteenResponse]);

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  const onCreateRulesSubmit = (e) => {
    e.preventDefault();
    dispatch(canteenActions.setRulesCreateLoading(true));
    dispatch(canteenActions.clearCanteenErrors());
    dispatch(canteenActions.clearCanteenResult());
    dispatch(canteenActions.createCanteenRules(values, loginType));
  };

  // skeleton
  const skeletonEffect = () => (
    <div className="col-lg-8">
      <Card isHeader={false}>
        <Skeleton height={150} />
        <Skeleton height={150} />
        <Skeleton height={70} />
      </Card>
    </div>
  );

  const renderRules = (rulesToShow) => {
    // console.log(rulesToShow);
    if (canteenLoading) {
      return (
        <>
          {skeletonEffect()}
          {skeletonEffect()}
          {skeletonEffect()}
          {skeletonEffect()}
        </>
      );
    } else if (!isEmpty(rulesToShow)) {
      return (
        <Card
          isHeader={true}
          header={
            <HeaderTag
              className="card-header bg-success text-white"
              title={
                rulesToShow?.locationId?.locationName +
                " -> " +
                rulesToShow?.locationCode
              }
              type="h6"
              isClassName={true}
            />
          }
        >
          <div className="table-responsive">
            <table className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap">
              <thead className="thead-light">
                <tr>
                  <th className="text-center">Break Fast In</th>
                  <th className="text-center">Break Fast Out</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="table-user text-center">
                    {rulesToShow?.breakFastIn}
                  </td>
                  <td className="table-user text-center">
                    {rulesToShow?.breakFastOut}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <div className="table-responsive">
            <table className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap">
              <thead className="thead-light">
                <tr>
                  <th className="text-center">Lunch In</th>
                  <th className="text-center">Lunch Out</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="table-user text-center">
                    {rulesToShow?.lunchIn}
                  </td>
                  <td className="table-user text-center">
                    {rulesToShow?.lunchOut}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <div className="table-responsive">
            <table className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap">
              <thead className="thead-light">
                <tr>
                  <th className="text-center">Dinner In</th>
                  <th className="text-center">Dinner Out</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="table-user text-center">
                    {rulesToShow?.dinnerIn}
                  </td>
                  <td className="table-user text-center">
                    {rulesToShow?.dinnerOut}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="mt-2">
            Created by : -{" "}
            {rulesToShow?.createdBy?.workerFirstName +
              " " +
              rulesToShow?.createdBy?.workerSurname || ""}
          </div>
        </Card>
      );
    } else {
      return (
        <Card>
          <h1 className="title">
            No Rules Found, Please Create rules
          </h1>
        </Card>
      );
    }
  };

  return (
    <Starter
      topBarTitle="Canteen Rules"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Canteen Rules Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Canteen Rules</a>
          </li>
          <li className="breadcrumb-item active">
            All Canteen Rules
          </li>
        </Fragment>
      }
    >
      <Card>
        <div className="row">
          <div className="col-lg-12">
            <Strong
              title="All inputs are compulsory*"
              className="text-danger float-right"
            />
            <HeaderTag
              type="h4"
              isClassName={false}
              title="Add Canteen Rules"
            />
            <P title="Fill the form below to add Add New Rules" />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3">
            <Button
              type="button"
              data-toggle="modal"
              isBackgroundColor={false}
              title="Create New Canteen Rules"
              data-target="#dark-canteen-header-modal"
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn mb-2 text-white btn-dark btn-block"
            />
          </div>
          <div className="col-lg-3">
            <SelectInput2
              data-tip
              isLabeled={true}
              name="locationId"
              value={locationId}
              data-for="locationId"
              label="Select Location"
              onChange={onLocationChange}
              placeholder="Select Location"
              icon="mdi mdi-map-marker-radius"
            >
              {isSuperAdmin(currentUser)
                ? renderLocationFunction(allLocations)
                : renderAccessLocation2(
                    locationRender(currentUser, false)
                  )}
            </SelectInput2>
          </div>
          <div
            tabIndex="-1"
            role="dialog"
            aria-hidden="true"
            id="dark-canteen-header-modal"
            className="modal fade"
            aria-labelledby="create-rules-modal"
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header modal-colored-header bg-dark">
                  <HeaderTag
                    type="h4"
                    className="modal-title"
                    id="create-rules-modal"
                    title="Create New Canteen Rules"
                  />
                  <Button
                    title="x"
                    type="button"
                    className="close"
                    aria-hidden="true"
                    data-dismiss="modal"
                    isBackgroundColor={false}
                  />
                </div>
                <form
                  className="pl-3 pr-3"
                  onSubmit={onCreateRulesSubmit}
                >
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-lg-4">
                        <SelectInput
                          required={true}
                          textWhite={false}
                          isLabeled={false}
                          onChange={handleInputChange}
                          name="locationId"
                          label="Select Location"
                          value={values.locationId}
                        >
                          <option value="">Select Location</option>
                          {isSuperAdmin(currentUser)
                            ? renderLocationFunction(locations)
                            : renderAccessLocation2(
                                locationRender(currentUser, false)
                              )}
                        </SelectInput>
                      </div>
                      <div className="col-lg-4">
                        <TextInput
                          type="time"
                          placeholder=""
                          name="breakFastIn"
                          required={true}
                          textWhite={false}
                          htmlFor="breakFastIn"
                          onChange={handleInputChange}
                          label="Break Fast In-Time"
                          value={values.breakFastIn}
                        />
                      </div>
                      <div className="col-lg-4">
                        <TextInput
                          type="time"
                          placeholder=""
                          required={true}
                          name="breakFastOut"
                          textWhite={false}
                          htmlFor="breakFastOut"
                          onChange={handleInputChange}
                          label="Break Fast Out-Time"
                          value={values.breakFastOut}
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-lg-6 col-md-6 col-xl-6 col-sm-6">
                        <TextInput
                          type="time"
                          placeholder=""
                          name="lunchIn"
                          required={true}
                          textWhite={false}
                          htmlFor="lunchIn"
                          onChange={handleInputChange}
                          label="Lunch In-Time"
                          value={values.lunchIn}
                        />
                      </div>
                      <div className="col-lg-6 col-md-6 col-xl-6 col-sm-6">
                        <TextInput
                          type="time"
                          placeholder=""
                          required={true}
                          name="lunchOut"
                          textWhite={false}
                          htmlFor="lunchOut"
                          onChange={handleInputChange}
                          label="Lunch Out-Time"
                          value={values.lunchOut}
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-lg-6 col-md-6 col-xl-6 col-sm-6">
                        <TextInput
                          type="time"
                          placeholder=""
                          name="dinnerIn"
                          required={true}
                          textWhite={false}
                          htmlFor="dinnerIn"
                          onChange={handleInputChange}
                          label="Dinner In-Time"
                          value={values.dinnerIn}
                        />
                      </div>
                      <div className="col-lg-6 col-md-6 col-xl-6 col-sm-6">
                        <TextInput
                          type="time"
                          placeholder=""
                          required={true}
                          name="dinnerOut"
                          textWhite={false}
                          htmlFor="dinnerOut"
                          onChange={handleInputChange}
                          label="Dinner Out-Time"
                          value={values.dinnerOut}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <Button
                      type="button"
                      title="Close"
                      data-dismiss="modal"
                      className="btn btn-light"
                      isBackgroundColor={false}
                    />
                    {createCanteenRuleLoading ? (
                      <SpinnerButton />
                    ) : (
                      <Button
                        type="submit"
                        title="Create Rules"
                        className="btn btn-dark"
                        isBackgroundColor={false}
                        icon="mdi mdi-plus-circle-outline mr-2"
                      />
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Card>
      <div className="row">
        <div className="col-lg-8">{renderRules(allCanteenRules)}</div>
      </div>
    </Starter>
  );
};

export default CreateCanteenRule;
